;(function($, undefined){
    "use strict";

    var rnn = window.rnn, log, maps, forms, Form, Field;   


    // Create UGC stub
    rnn.modules.register('ugc2', {});

}(jQuery));